import { useEffect, useState } from "react";
import { JobPartCategory } from "../../models/Job";
import classNames from "../../utils/classNames";
import openInNewTab from "../../utils/openInNewTab";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import ContactFromId from "../contacts/ContactFromId";
import RsCoreImage from "../core/RsCoreImage";


interface JobPartProps {
  partCategory: JobPartCategory;
  markAsRemoved: (partData: JobPartCategory['partData']) => void;
  setDamaged: (partData: JobPartCategory['partData']) => void;
  setDamagedOpen: (open: boolean) => void;
  handlePrint: (partData: JobPartCategory['partData']) => void;
  selectedPartIds: Set<string>;
  togglePartSelection: (partId: string | null | undefined) => void;
}

export default function JobPart({ partCategory, markAsRemoved, setDamaged, setDamagedOpen, handlePrint, selectedPartIds, togglePartSelection }: JobPartProps) {

  const [notes, setNotes] = useState(partCategory.partData?.internalNotes);
  const isSelected = partCategory.partData?.id ? selectedPartIds.has(partCategory.partData.id) : false;
  const isDeleted = !!(partCategory.partData as any)?.deleted;

  return (
    <div key={partCategory.id} className={`p-4 rounded-md space-y-4 ${isDeleted ? 'bg-red-100' : 'bg-white'} ${isSelected ? 'ring-2 ring-blue-500' : ''}`}>
      <div className="flex gap-x-2 items-center">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => togglePartSelection(partCategory.partData?.id)}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
          disabled={!partCategory.partData?.id}
        />
        <p className="text-lg font-semibold">{partCategory.partData?.title} - <span className="text-base font-medium">{partCategory.partData?.tagNumber}</span></p>

        {partCategory.partData?.removedOn && (
          <p className="font-semibold text-green-600">REMOVED</p>
        )}
        {partCategory.partData?.isDamaged && (
          <p className="font-semibold text-red-600">DAMAGED</p>
        )}
        {partCategory.partData?.isCore && (
          <RsCoreImage className="ml-auto !h-6" />
        )}
      </div>

      <div className="flex flex-col md:flex-row gap-x-4 gap-y-2">

        {!partCategory.partData?.isDamaged && (
          <>
            <ButtonInput
              label={"Mark Removed"}
              isSubmit={false}
              onClick={() => markAsRemoved(partCategory.partData!)}
              classes={classNames(partCategory.partData?.removedOn ? "" : "!bg-green-600 hover:!bg-green-700", "!py-1 !px-1")}
              disabled={partCategory.partData?.removedOn !== null}
            />
            <ButtonInput
              label={"Mark Damaged"}
              isSubmit={false}
              onClick={() => { setDamaged(partCategory.partData); setDamagedOpen(true); }}
              classes={"!py-1 !px-1 !bg-red-600 hover:!bg-red-700"}
            />
          </>
        )}

        <ButtonInput
          label={"View Stock"}
          isSubmit={false}
          onClick={() => openInNewTab(`/stock/${partCategory.partData?.id}`)}
          classes={"!py-1 !px-1 "}
        />

        <ButtonInput
          label={"Print Label"}
          isSubmit={false}
          onClick={() => handlePrint(partCategory.partData!)}
          classes={"!py-1 !px-1 "}
        />
      </div>

      {notes && notes.length > 0 &&
        <div>
          <h1>Internal Part Notes:</h1>
          <ul className="text-sm list-disc">
            {notes.map((note) => (
              <li className="ml-5">{note.message} - <ContactFromId contactId={note.createdBy} /></li>
            ))}
          </ul>
        </div>
      }
    </div>
  )
}